import React, { useEffect } from 'react';
import { notification } from 'antd';
import { setNotificationApi } from '../store/utils';

const NotificationProvider: React.FC = () => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    setNotificationApi(api);
  }, [api]);

  return <>{contextHolder}</>;
};

export default NotificationProvider;
